function isEmpty(value) {
  return value === "" || value === null || value === undefined;
}

function validateIntegerGreaterOrEqualZero(value, fieldName) {
  if (isEmpty(value) || Number.isNaN(Number(value))) {
    return `${fieldName} es obligatorio.`;
  }

  if (!Number.isInteger(Number(value)) || Number(value) < 0) {
    return `${fieldName} debe ser un entero mayor o igual a 0.`;
  }

  return null;
}

function validateDecimalGreaterOrEqualZero(value, fieldName) {
  if (isEmpty(value) || Number.isNaN(Number(value))) {
    return `${fieldName} es obligatorio.`;
  }

  if (Number(value) < 0) {
    return `${fieldName} debe ser mayor o igual a 0.`;
  }

  return null;
}

export function validateClientCityRangePayload({ min_km, max_km, price_km }) {
  const minKmError = validateIntegerGreaterOrEqualZero(
    min_km,
    "El kilometro minimo",
  );
  if (minKmError) {
    return minKmError;
  }

  const maxKmError = validateIntegerGreaterOrEqualZero(
    max_km,
    "El kilometro maximo",
  );
  if (maxKmError) {
    return maxKmError;
  }

  if (Number(max_km) < Number(min_km)) {
    return "El kilometro maximo debe ser mayor o igual al kilometro minimo.";
  }

  const priceKmError = validateDecimalGreaterOrEqualZero(
    price_km,
    "El precio por kilometro",
  );
  if (priceKmError) {
    return priceKmError;
  }

  return null;
}
